/*
 * @description:
 * @author: Jason Wong
 * @since: 2024-07-12 17:50:32
 */
import { get } from "lodash";
import { getMenu, getAllPermissions, getAuthorizedPermissions } from "../../api/account";
import appRouter from "../../router";

const TOP_MENU_PACK_NAME = "top_menu_pack";

const permissionStore = {
    state: {
        wholeMenuPacks: [],
        topMenuList: [],
        leftMenuList: [],
        isMenuLoaded: false,
    },
    mutations: {
        setMenuLoadState(state, isMenuLoaded) {
            state.isMenuLoaded = isMenuLoaded;
        },
    },
    actions: {
        async loadMenu({ state }) {
            console.log("loadMenu", state);
            this.isMenuLoaded = false;
            try {
                const data = await getAuthorizedPermissions();
                state.wholeMenuPacks = data || [];
                const topMenu = (data || []).filter((item) => item.packName === TOP_MENU_PACK_NAME);
                state.topMenuList = (topMenu[0] || []).permissions || [];
                this.isMenuLoaded = true;
            } catch (error) {
                state.isMenuLoaded = false;
                console.error(error);
                throw error;
            }
        },
        switchLeftMenu({ state }, menuPackName) {
            console.log("#-# switchLeftMenu");
            const tempPack = state.wholeMenuPacks.find((item) => item.packName === menuPackName);
            var leftMenuList = (tempPack || {}).permissions || [];
            state.leftMenuList = leftMenuList;
        },
    },
    getters: {
        isMenuLoaded: (state) => state.isMenuLoaded,
        getTopMenu: (state) => state.topMenuList,
        getLeftMenu: (state) => state.leftMenuList,
        getWholeMenuPacks: (state) => state.wholeMenuPacks,
    },
};

export default permissionStore;
